import { CanActivateFn, Router } from '@angular/router';
import { UserInformationService } from '@core/services/user-data/user-data.service';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export const AllowedOrganizationGuard: CanActivateFn =
  async (): Promise<boolean> => {
    const userInformationService = inject(UserInformationService);
    const routing = inject(Router);

    try {
      await userInformationService.fetchUserDataFromRBSByID('cache-first');
      if (!userInformationService.userOrganizationRoles.value) {
        routing.navigate(['/unauthorized']);
        return false;
      }
      const userOrgRoles = await firstValueFrom(
        userInformationService.userOrganizationRoles,
      );

      if (userOrgRoles && userOrgRoles.length > 0) {
        const rbsResponse =
          await userInformationService.fetchAllowedOrganizations(
            userOrgRoles.map((role) => role.organizationId),
          );

        if (!rbsResponse) {
          routing.navigate(['/unauthorized']);
        }

        return !!rbsResponse;
      }
      routing.navigate(['/unauthorized']);
      return false;
    } catch (error) {
      console.error('Error fetching user organization roles:', error);
      routing.navigate(['/unauthorized']);
      return false;
    }
  };
